import React from 'react';
import { Grid, Switch as MuiSwitch } from '@mui/material';
import styled from 'styled-components';
import { Text } from './Text'; 

export const Switch = ({
  inactiveText = 'Off',
  activeText = 'On',
  onChange,
  defaultValue
}) => {
  const [checked, setChecked] = React.useState(false);

  const handleChange = event => {
    setChecked(event.target.checked);
    onChange(event.target.checked);
  };

  React.useEffect(() => {
    if (defaultValue) {
      setChecked(defaultValue);
    }
  }, [defaultValue]);

  return (
    <Container>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>{inactiveText}</Grid>
        <Grid item>
          <MuiSwitch checked={checked} onChange={handleChange} />
        </Grid>
        <Grid item>{activeText}</Grid>
      </Grid>
    </Container>
  );
};

export const Container = styled(Text)`
  display: inline-block;
  margin-left: 20px;
`;

